import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const CONSENT_KEY = "cookie_consent_status";
const CONSENT_ACCEPTED = "accepted";
const CONSENT_REJECTED = "rejected";
const POSTHOG_KEY = "phc_xAvL2Iq4tFmANRE7kzbKwaSqp1HJjN7x48s3vr0CMjs";
const POSTHOG_HOST = "https://us.i.posthog.com";

const initPosthog = () => {
  if (window.__posthogInitialized) return;
  (function (t, e) {
    var o, n, p, r;
    e.__SV ||
      ((window.posthog = e),
      (e._i = []),
      (e.init = function (i, s, a) {
        function g(t, e) {
          var o = e.split(".");
          2 == o.length && ((t = t[o[0]]), (e = o[1])),
            (t[e] = function () {
              t.push(
                [e].concat(Array.prototype.slice.call(arguments, 0)),
              );
            });
        }
        ((p = t.createElement("script")).type = "text/javascript"),
          (p.crossOrigin = "anonymous"),
          (p.async = !0),
          (p.src =
            s.api_host.replace(
              ".i.posthog.com",
              "-assets.i.posthog.com",
            ) + "/static/array.js"),
          (r = t.getElementsByTagName("script")[0]).parentNode.insertBefore(
            p,
            r,
          );
        var u = e;
        for (
          void 0 !== a ? (u = e[a] = []) : (a = "posthog"),
            u.people = u.people || [],
            u.toString = function (t) {
              var e = "posthog";
              return (
                "posthog" !== a && (e += "." + a),
                t || (e += " (stub)"),
                e
              );
            },
            u.people.toString = function () {
              return u.toString(1) + ".people (stub)";
            },
            o =
              "init me ws ys ps bs capture je Di ks register register_once register_for_session unregister unregister_for_session Ps getFeatureFlag getFeatureFlagPayload isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSurveysLoaded onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey canRenderSurveyAsync identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty Es $s createPersonProfile Is opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing Ss debug xs getPageViewId captureTraceFeedback captureTraceMetric".split(
                " ",
              ),
            n = 0;
          n < o.length;
          n++
        )
          g(u, o[n]);
        e._i.push([i, s, a]);
      }),
      (e.__SV = 1));
  })(document, window.posthog || []);
  window.posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    person_profiles: "identified_only",
    session_recording: {
      recordCrossOriginIframes: true,
      capturePerformance: false,
    },
  });
  window.__posthogInitialized = true;
};

const CookieConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(CONSENT_KEY);
    if (stored === CONSENT_ACCEPTED) {
      initPosthog();
      setVisible(false);
    } else if (stored === CONSENT_REJECTED) {
      if (window.posthog?.opt_out_capturing) {
        window.posthog.opt_out_capturing();
      }
      setVisible(false);
    } else {
      setVisible(true);
    }

    const openCookieSettings = () => {
      setVisible(true);
    };

    window.addEventListener("open-cookie-settings", openCookieSettings);
    return () => {
      window.removeEventListener("open-cookie-settings", openCookieSettings);
    };
  }, []);

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, CONSENT_ACCEPTED);
    initPosthog();
    setVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem(CONSENT_KEY, CONSENT_REJECTED);
    if (window.posthog?.opt_out_capturing) {
      window.posthog.opt_out_capturing();
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-slate-800 bg-[#0b1120]/95 backdrop-blur px-6 py-4"
      data-testid="cookie-consent-banner"
    >
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <p className="text-sm text-slate-200">
          We use cookies to improve your experience and analyze site usage. Read
          our{" "}
          <Link
            to="/cookie-policy"
            className="text-[#22c55e] underline"
            data-testid="cookie-policy-link"
          >
            Cookie Policy
          </Link>
          . You can accept or reject non-essential cookies.
        </p>
        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={handleReject}
            className="px-4 py-2 text-sm text-slate-200 border border-slate-600 rounded"
            data-testid="cookie-reject-button"
          >
            Reject
          </button>
          <button
            type="button"
            onClick={handleAccept}
            className="px-4 py-2 text-sm font-semibold text-[#0b1120] bg-[#22c55e] rounded"
            data-testid="cookie-accept-button"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;